module.exports = __webpack_public_path__ + "static/media/icon-photo-check.fb7493ae.svg";